function initializeLinkedOptions() {
  const availableVariants = JSON.parse(document.getElementById('product-variants-json').textContent);
  const optionWrappers = document.querySelectorAll('.selector-wrapper');

  if (!availableVariants || !optionWrappers.length) return;

  const getCurrentSelections = () => {
    return Array.from(optionWrappers).map(wrapper => {
      const selected = wrapper.querySelector('.clickyboxes a.selected');
      return selected ? selected.dataset.value : null;
    });
  };

  const disableVariantOutOfStock = (selectedValues) => {
    const swatchGroups = document.querySelectorAll('ul.clickyboxes');

    swatchGroups.forEach((group, groupIndex) => {
      const swatches = group.querySelectorAll('a[data-value]');

      swatches.forEach(swatch => {
        const optionValue = swatch.getAttribute('data-value');
        if (!optionValue) return;

        // Build a test combination based on current selections
        const testCombination = [...selectedValues];
        testCombination[groupIndex] = optionValue;

        // Check if this combination exists in availableVariants
        const matchingVariant = availableVariants.find(v =>
          v.available && v.options.every((opt, idx) => {
            return testCombination[idx] === null || testCombination[idx] === opt;
          })
        );

        if (!matchingVariant) {
          // Mark as unavailable
          swatch.classList.add("unavailable");
        } else {
          // Mark as available
          swatch.classList.remove("unavailable");
        }
      });
    });
  };

  // Initial run
  const initialSelection = getCurrentSelections();
  disableVariantOutOfStock(initialSelection);

  // Handle swatch clicks
  document.querySelectorAll(".clickyboxes").forEach((ul, groupIndex) => {
    ul.addEventListener("click", function (event) {
      const clickedElement = event.target;

      if (clickedElement.tagName === "A" && !clickedElement.classList.contains("unavailable")) {
        event.preventDefault();

        // Clear selection in this group
        ul.querySelectorAll("a").forEach(a => a.classList.remove("selected"));
        clickedElement.classList.add("selected");

        const currentSelections = getCurrentSelections();
        disableVariantOutOfStock(currentSelections);
      }
    });
  });
}
